import { render, staticRenderFns } from "./Sinisters.vue?vue&type=template&id=e1254056&scoped=true&"
import script from "./Sinisters.vue?vue&type=script&lang=js&"
export * from "./Sinisters.vue?vue&type=script&lang=js&"
import style0 from "./Sinisters.vue?vue&type=style&index=0&id=e1254056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1254056",
  null
  
)

export default component.exports